// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1EObo","warning":"Button_warning__255iE","danger":"Button_danger__qUIDB","success":"Button_success__DaKt5","action":"Button_action__s0Eqv"};